import { Erc721MetaJson } from '@xyo-network/sdk-xyoworld-js'
import { createContext } from 'react'

export const Erc721MetaDataContext = createContext<Erc721MetaJson>({})
